import { render, staticRenderFns } from "./select_incidenttype.vue?vue&type=template&id=d67d929e&scoped=true"
import script from "./select_incidenttype.vue?vue&type=script&lang=js"
export * from "./select_incidenttype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67d929e",
  null
  
)

export default component.exports